<template>
  <div>
     <div class="whatsapp-notification-main-checkbox" v-if="show_consent">
      <input class="mr-8" v-model="status" type="checkbox" @click="postOpted" />
      <p class="para">
        Receive notification regarding the order in your WhatsApp
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Checkbox",

  data() {
    return {
      status: false,
      mobile: "",
      show_consent: false,
    };
  },

  mounted() {
    this.getStatus();
  },
  methods: {
    getStatus() {
      if (window.FPI.state.user._data.user.user_id) {
        this.show_consent = true;
        axios({
          method: "get",
          url: `${window.location.origin}/ext/whatsapp_proxy/application/proxy/opted-status-get?phone_number=${window.FPI.state.user._data.user.phone_numbers[0].phone}`,
        })
          .then((response) => {
            this.mobile = response.data.phone_number;
            this.status = response.data.is_opted;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.show_consent = false;
      }
    },
    postOpted() {
      const data = {
        is_opted: !this.status,
        phone_number: window.FPI.state.user._data.user.phone_numbers[0].phone,
      };

      axios({
        method: "post",
        url: `${window.location.origin}/ext/whatsapp_proxy/application/proxy/opted-status-post`,
        data,
      })
        .then((response) => {
          console.log("res", response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
.whatsapp-notification-main-checkbox {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  /* width: 100%; */
  margin-left: 15px;
}
.mr-8 {
  margin-right: 10px;
  margin-bottom: 22px;
}
.whatsapp-notification-main-checkbox .para {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #828282;
  line-height: 20px;
}
input.mr-8 {
  width: 18px;
  height: 18px;
}
</style>
